import React from 'react';
import { Route, Switch } from 'react-router-dom';

function parseQuery(search) {
  if (!search) return {};
  const s = search[0] === '?' ? search.slice(1) : search;
  const params = new URLSearchParams(s);
  const query = {};
  params.forEach((value, key) => {
    query[key] = value;
  });
  return query;
}

export default function renderRoutes(routes, extraProps = {}) {
  if (!routes) return null;

  const store = extraProps && extraProps.store;
  const dispatch = store && typeof store.dispatch === 'function' ? store.dispatch : undefined;
  const getState = store && typeof store.getState === 'function' ? store.getState : undefined;

  return (
    <Switch>
      {routes.map((route, i) => {
        const { path, exact, strict, component: Component } = route;

        if (!Component) {
          return null;
        }

        return (
          <Route
            key={route.key || path || i}
            path={path}
            exact={exact}
            strict={strict}
            render={(props) => {
              const params = props.match && props.match.params ? props.match.params : {};
              const locationQuery = props.location && props.location.query ? props.location.query : parseQuery(props.location && props.location.search);
              const location = props.location ? { ...props.location, query: locationQuery } : props.location;
              const children = route.routes ? renderRoutes(route.routes, extraProps) : null;
              return (
                <Component
                  {...extraProps}
                  {...props}
                  location={location}
                  dispatch={dispatch}
                  getState={getState}
                  params={params}
                  route={route}
                >
                  {children}
                </Component>
              );
            }}
          />
        );
      })}
    </Switch>
  );
}
